import React from 'react';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import Image from 'gatsby-image';

import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Button from 'components/Button';
import LinkTo from 'components/LinkTo';

const HomePage = ({ location }: { location: Location }) => {
  const {
    file: {
      childImageSharp: { fluid },
    },
    site: {
      siteMetadata: { author },
    },
  } = useStaticQuery(graphql`
    query {
      file(name: { eq: "bryan-galdamez" }) {
        childImageSharp {
          fluid(maxWidth: 570, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      site {
        siteMetadata {
          author
        }
      }
    }
  `);

  return (
    <Layout location={location}>
      <SEO title='About Me' />
      <div className='col-span-full grid grid-cols-1 bg-white border-.1 border-solid border-gray-200 shadow-md rounded-xl transition-shadow p-10 hover:shadow-xl'>
        <div className='grid grid-cols-1 md:grid-cols-2'>
          <div className='col-span-1 grid grid-cols-1 text-justify md:text-left'>
            <h1 className='text-4xl font-bold mt-5 mb-3'>{author}</h1>
            <h2 className='text-xl font-bold my-2'>Who I am?</h2>
            <p className='text-lg font-light mb-3'>
              I'm a eighteen y/o software development living in El Salvador. I'm in love with videogames, i love them so much
              that I wanted to be a videogames developer a few years ago. But later in 2020 I discovered the amazing world of
              Web Development <span className='italic font-semibold'>(Yes, I'm looking at you, JQuery and PHP)</span> . I
              actually didn't started to love this world until i discovered VueJS{' '}
              <span className='italic font-semibold'>
                (something strange, 'cause this site is made in Gatsby, which uses React, but yeah)
              </span>
              , and I started to interest in it. But i didn't dig any deeper, but for a homework.
            </p>
            <p className='text-lg font-light mb-3'>
              Then, for a job offer I started to learn <span className='font-bold'>React</span>. And now you're reading this...
              I really liked it.
            </p>
            <p className='text-lg font-light mb-3'>
              Talking more about myself, I've developed in the past in Java and C#, worked with Maria DB, SQL Server and
              PostgreSQL <span className='italic font-semibold'>(omg, I love this one)</span>.
            </p>
            <p className='text-lg font-light mb-3'>And yeah, I love cats, probably you're going to see one or two here.</p>
            <p className='text-lg font-light mb-3'>If you're interested in my work, you can see my projects here: </p>
            <Button
              callback={() => navigate('/projects')}
              icon='bx-list-check'
              innerText='My projects'
              className='w-max justify-self-center'
            />
            <p className='text-lg font-light mt-10 mb-3'>
              And if you want to follow me or just see pics of my cats, you can follow me on
            </p>
            <div className='flex gap-3 justify-self-center'>
              <LinkTo href='https://instagram.com/josuegalre' icon='bxl-instagram' innerText='Instagram' className='w-max' />
              <LinkTo href='https://twitter.com/josuegalre/' icon='bxl-twitter' innerText='Twitter' className='w-max' />
            </div>
          </div>
          <div className='flex flex-wrap col-span-1 mt-10 md:mt-0 content-center justify-center'>
            <Image fluid={fluid} className='rounded-xl h-auto w-8/12 ' />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
